import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { StyledToolTipContent } from '../style';
import { IProductResponse } from '../../../utils/types';
import { TooltipSection } from '../types';

const getProductsSrcMap = (
  products: IProductResponse[],
): Record<string, string> => {
  if (!products || !products.length) return {};

  return products.reduce((accumulator, { publisherProductId, images }) => {
    const img = images.find(({ type }) => type === 'product')?.url;

    return img ? { ...accumulator, [publisherProductId]: img } : accumulator;
  }, {});
};

interface IExtendedTooltipTitleProps {
  titleImg: string;
  title: string;
  sections: TooltipSection[];
  isOpen: boolean;
  tooltipLoadCallback?: (arr: string[]) => Promise<IProductResponse[]>;
  productIds: string[];
}
export const ExtendedTooltipTitle: React.FC<IExtendedTooltipTitleProps> = ({
  titleImg,
  title,
  sections,
  isOpen,
  tooltipLoadCallback,
  productIds,
}) => {
  const [mapProductSrc, setMapProductSrc] = useState<Record<string, string>>(
    {},
  );

  useEffect(() => {
    if (isOpen) {
      if (tooltipLoadCallback && productIds.length > 0) {
        tooltipLoadCallback(productIds)
          .then(getProductsSrcMap)
          .then(setMapProductSrc);
      } else {
        setMapProductSrc({});
      }
    }
  }, [isOpen]);

  return (
    <StyledToolTipContent>
      {title && titleImg && (
        <div className={'heading'}>
          <div className={'heading--image-container'}>
            <img
              className={'heading--image-container__img'}
              src={titleImg}
              alt={'img'}
            />
          </div>
          <Typography className={'heading--text'}>{title}</Typography>
        </div>
      )}
      {sections.map(({ sectionName, products }) => (
        <div className={'section'}>
          <div className={'divider'} />
          {sectionName && (
            <Typography className={'section--name'}>{sectionName}</Typography>
          )}
          <ul className={'section--list'}>
            {products.map(({ publisherProductId, text }, i) => (
              <li key={i} className={'section--list__item'}>
                {mapProductSrc[publisherProductId] && (
                  <div className={'item--image-container'}>
                    <img
                      src={mapProductSrc[publisherProductId]}
                      alt={'coin'}
                      className={'item--image-container__img'}
                    />
                  </div>
                )}
                <Typography className={'item--text'}>{text}</Typography>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </StyledToolTipContent>
  );
};
